export const OPEN_MENU_ITEMS_TO_OPEN = {
    DEFAULT: '',
    SIGNUP: 'signup',
    SIGNIN: 'signin',
    FORGOT: 'forgot',
    ACCOUNT: 'account',
} as const;

export type VisibilityMenuType = {
    visible: boolean;
    openMenuItem: $Values<typeof OPEN_MENU_ITEMS_TO_OPEN>;
};
